import React from 'react';
import styled from 'styled-components';
import { Link } from 'gatsby';
import '../styles/hamburgers.min.css';

import ButtonLink from './global/button-link';

const NavMenuStyle = styled.div`
	width: 100%;
	background-color: ${(p) => p.theme.color.dark};
	padding-top: 1rem;

	.overlay {
		width: 100%;
		height: calc(100% + 1rem);
		top: -1rem;
		z-index: 9;
		position: relative;
		&.isOpen {
			position: fixed;
		}
		@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
			opacity: 0;
			transition: opacity 0.3s;
			background-color: rgba(0, 0, 0, 0.5);
			&.isOpen {
				opacity: 1;
			}
		}
	}

	.inner {
		display: flex;
		margin: 0 2.5rem;
		.show-mobile {
			display: none !important;
		}

		.brand {
			flex: 0 0 auto;
			padding: 10px 0;
			img {
				width: 190px;
			}
		}
		nav.pages {
			flex: 1 1 auto;
			display: flex;
			justify-content: flex-end;
			padding: 1.25rem 0;
			ul {
				list-style-type: none;
				height: 2.5rem;
				li {
					display: inline-block;
					font-size: 1rem;
					margin-right: 2rem;
					line-height: 2.5rem;
					&:not(.button-link) {
						a {
							color: #fff;
							letter-spacing: 0.2em;
							font-weight: 400;
							text-decoration: none;
							position: relative;
							&::after {
								content: '';
								background-color: #fff;
								transition: 0.3s width;
								width: 0;
								height: 2px;
								position: absolute;
								bottom: 0;
								left: 0;
							}
							&:hover::after {
								width: 98%;
							}
						}
					}
					&.button-link {
						margin-right: 0;
						padding: 0;
					}
				}
			}
		}
	}
	@media all and (max-width: 1100px) {
		.inner {
			justify-content: space-between;
			align-items: center;
			.show-mobile {
				display: block !important;
			}

			.mobile-donate {
				margin-right: 6.4rem;
				border-radius: 2rem;
			}
			.brand-right {
				display: flex;
				align-items: center;
			}
			nav.pages {
				display: none;
			}
		}
	}

	@media all and (max-width: 550px) {
		padding-top: 0.5rem;
		.inner {
			.brand img {
				height: 50px;
			}

			.mobile-donate {
				margin-right: 3.5rem;
				border-radius: 2rem;
				padding: 0 1.5rem;
				line-height: 2rem;
				font-size: 0.8rem;
			}
		}
	}
	@media all and (max-width: 450px) {
		.inner {
			height: 70px;

			.brand {
				img {
					height: 40px;
					width: auto;
				}
			}

			.brand-right {
				.mobile-donate {
					margin-right: 2.5rem;
				}
			}
		}
	}
	@media all and (max-width: 360px) {
		.inner {
			height: 70px;

			.brand-right {
				.mobile-donate {
					transform: scale(0.8);
					margin-right: 1.5rem;
				}
			}
		}
	}
	@media all and (max-width: 359px) {
		.inner {
			.brand {
				img {
					height: 35px;
				}
			}
		}
	}
`;

const NavMenu = ({ setOpen, isOpen }) => {
	return (
		<NavMenuStyle>
			<div
				className={isOpen ? 'overlay isOpen' : 'overlay'}
				onClick={() => setOpen(false)}
			/>
			<div className="inner">
				<div className="brand">
					<Link to="/">
						<img src="/img/StartTalking_Logo.svg" alt="Start Talking logo" />
					</Link>
				</div>
				<div className="brand-right show-mobile">
					<ButtonLink className="mobile-donate" to="/donate/">
						DONATE
					</ButtonLink>
				</div>
				<nav className="pages">
					<ul>
						<li>
							<Link className="about" to="/about/">
								ABOUT
							</Link>
						</li>
						<li>
							<Link className="education" to="/education/">
								EDUCATION
							</Link>
						</li>
						<li>
							<Link className="stories" to="/stories/">
								STORIES
							</Link>
						</li>
						<li>
							<Link className="events" to="/events/">
								EVENTS
							</Link>
						</li>
						<li>
							<Link className="contact" to="/contact/">
								CONTACT
							</Link>
						</li>
						<li className="button-link">
							<ButtonLink className="menu-donate" to="/donate/">
								DONATE
							</ButtonLink>
						</li>
					</ul>
				</nav>
			</div>
		</NavMenuStyle>
	);
};
export default NavMenu;
